import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";
import { makeAdditionalSearchableFeature } from "@navigationRouting/utils";

import type { I18nT } from "@lib/dashboardI18n";

const CurrentsIntegrationsForNro = lazy(() =>
  import("@scenes/CurrentsIntegrationsList/CurrentsIntegrationForNro").then((module) => ({
    default: module.CurrentsIntegrationForNro,
  }))
);

export const currentsIntegrationsNRO: NavigationRoutingObject = {
  Component: CurrentsIntegrationsForNro,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "partner-integrations",
  heading: (t: I18nT<"dashboard-navigation">) => t("currents-sidebar-new-pill-menu-option", "Currents"),
  pageNameForTracking: () => "Currents",
  description: (t: I18nT<"dashboard-navigation">) =>
    t("currents-description-nav", "Create and manage your Currents connections"),
  icon: "nav-system-data-export",
  featureLimitationKeys: ["can_only_view_landing_page_currents"],
  getDeveloperNavigationAllowed: ({ featureOn }) => {
    // Allow navigation for paid customers with entitlement OR free trial users (who see landing page)
    return featureOn("currents_integrations") || featureOn("free_trial_nro_nav");
  },
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      keywords: [t("currents", "Currents")],
      description: t("previously-currents", 'Previously "Currents"'),
    },
    {
      keywords: [
        t("currents-integrations-alt-keyword-1", "test current"),
        t("currents-integrations-alt-keyword-2", "currents integrations"),
        t("currents-integrations-alt-keyword-3", "Google Cloud Storage Data Export"),
        t("currents-integrations-alt-keyword-4", "Amazon S3 Data Export"),
        t("currents-integrations-alt-keyword-5", "Adobe Export"),
        t("currents-integrations-alt-keyword-6", "Amplitude Export"),
        t("currents-integrations-alt-keyword-7", "Azure Blob Data Export"),
        t("currents-integrations-alt-keyword-8", "EventBridge Export"),
        t("currents-integrations-alt-keyword-9", "Heap Export"),
        t("currents-integrations-alt-keyword-10", "Mixpanel Export"),
        t("currents-integrations-alt-keyword-11", "mParticle Export"),
        t("currents-integrations-alt-keyword-12", "Rudderstack Export"),
        t("currents-integrations-alt-keyword-13", "Segment Data Export"),
        t("currents-integrations-alt-keyword-14", "Tealium Export"),
        t("currents-integrations-alt-keyword-15", "Treasure Data Export"),
      ],
    },
  ],
  additionalSearchableFeatures: (t: I18nT<"dashboard-navigation">) => ({
    currents_integrations: makeAdditionalSearchableFeature({
      heading: t("data-export-sidebar-new-pill-menu-option", "Data Export"),
      pathname: "/integrations/currents_integrations/currents_integrations/:appGroupId",
      description: t("currents-description-nav", "Create and manage your Currents connections"),
      query: { currentsIntegrations: "currents_integrations" },
      additionalSearchTerms: [],
    }),
  }),
  defaultRoute: "/integrations/currents_integrations/:appGroupId",
};
